<div class="cr-decisions" [class.open]="open">
  <div class="cr-decisions-head">
    <button type="button" class="cr-decisions-toggle" (click)="open = !open">
      <span class="cr-decisions-title">DECISIONS</span>
      <svg class="cr-decisions-caret" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m10 7 5 5-5 5" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"></path></svg>
    </button>
    <span class="cr-decisions-counts">
      <span class="cr-decision-count tone-red"><i></i>{{ counts.red }}</span>
      <span class="cr-decision-count tone-amber"><i></i>{{ counts.amber }}</span>
      <span class="cr-decision-count tone-green"><i></i>{{ counts.green }}</span>
    </span>
  </div>
  <div class="cr-decisions-body" *ngIf="open">
    <div class="cr-decision-row" *ngFor="let d of decisions">
      <span class="cr-decision-dot" [ngClass]="'tone-' + typeOf(d).tone" aria-hidden="true"></span>
      <span class="cr-decision-copy">
        <span class="cr-decision-label">{{ typeOf(d).label }}</span>
        <span class="cr-decision-author">{{ authorOf(d) }}</span>
        <span class="cr-decision-comment" *ngIf="d.comment">{{ d.comment }}</span>
      </span>
    </div>
    <div class="cr-decision-empty" *ngIf="decisions.length === 0">No decision on this version yet.</div>
  </div>
  <div class="cr-decision-form" *ngIf="formOpen; else addBtn">
    <label class="cr-decision-option" *ngFor="let t of types" [class.selected]="selectedType === t.key">
      <input type="radio" name="cr-review-decision" [value]="t.key" [(ngModel)]="selectedType" />
      <span class="cr-decision-option-mark" [ngClass]="'tone-' + t.tone" aria-hidden="true"></span>
      <span>{{ t.label }}</span>
    </label>
    <textarea class="cr-decision-input" [(ngModel)]="comment" placeholder="Add comment..."></textarea>
    <div class="cr-decision-form-actions">
      <button type="button" class="cr-btn cr-btn-primary" [disabled]="!selectedType" (click)="submit()">Submit decision</button>
      <button type="button" class="cr-btn cr-btn-secondary" (click)="cancel()">Cancel</button>
    </div>
  </div>
  <ng-template #addBtn>
    <button type="button" class="cr-decision-add" (click)="formOpen = true"><span>Add decision</span></button>
  </ng-template>
</div>
